import { Project } from './types';

export function filterVisibleProjects(projects: Project[], query: string) {
  const normalizedQuery = query.toLowerCase().trim();

  return projects
    .filter(project => !project.deleted)
    .filter(project => {
      if (!normalizedQuery) {
        return true;
      }

      const haystack =
        `${project.name} ${project.description} ${project.organization}`
          .toLowerCase()
          .trim();
      return haystack.includes(normalizedQuery);
    });
}

export function useProjectSearch(projects: Project[], query: string) {
  const visibleProjects = projects.filter(project => !project.deleted);
  const filteredProjects = filterVisibleProjects(projects, query);

  const totalArtifacts = visibleProjects.reduce(
    (count, project) => count + project.artifacts.length,
    0,
  );
  const totalWorkItems = visibleProjects.reduce(
    (count, project) => count + project.workItems.length,
    0,
  );

  return {
    filteredProjects,
    totalArtifacts,
    totalWorkItems,
    visibleProjects,
  };
}
